<div *ngIf="standardPricePreview || basicPricePreview || pricePerOrderUnitPreview">
  <hr />
  <div class="price-preview-header">{{ 'Vorschau' | translate }}</div>
  <p *ngIf="standardPricePreview as standardPrice" class="price-preview-line">
    {{ 'Preis' | translate }}: {{ standardPrice }}
  </p>
  <p *ngIf="basicPricePreview as basicPrice" class="price-preview-line">
    {{ 'Grundpreis' | translate }}: {{ basicPrice }}
  </p>
  <p *ngIf="pricePerOrderUnitPreview as pricePerOrderUnit" class="price-preview-line">
    {{ 'Preis je Bestelleinheit' | translate }}: {{ pricePerOrderUnit }}
  </p>
</div>
